import * as commonActions from './common'
import * as clientServices from './client-services'

export default {
    ...commonActions,
    ...clientServices
}

